module.exports = __webpack_public_path__ + "static/img/comunicadoSuspencionServiciosCI.ca9b49e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comunicadoSuspencionServiciosCI.jpg
// module id = tbpb
// module chunks = 9